//#region Util Imports

import * as _ from 'underscore'
import * as moment from 'moment'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { OpDataList } from '../../../../models/util/op-data-list'
import { IReferenceType, IOpObject, IOpData } from '../../../../models/util/interfaces'
import { OpDataType } from '../../../../models/core/op-data-type'
import { OpProfileData } from '../../../../models/core'
import { OpDataTypeInGroup } from '../../../../models/core/op-data-type-in-group'
import { FieldNameValueModel } from '../../../api/api.models'
import { CommonHelper } from '../../../../helpers/common-helper'
import { Md5 } from './../../../../helpers/md5-helper'
import { EventsNames } from '../../../../helpers/events-names'
import { Api, LocalDictionaryFactory } from '../../../api/api.module'
import { CommonCreateEdit, CreateEditField, CreateEditSection, CreateEditFieldSettings } from './../../../common/common.create-edit'
import { Enums } from '../../../../models/common/enums'
import { Dictionary } from '../../../../helpers/dictionary'
import { ReferenceTypeComponent } from '../../../../helpers/reference-type-component'
import { ConfigHelper } from '../../../../helpers/config-helper'
import { LocalizationHelper } from '../../../../helpers/localization-helper'
import { TypeHelper } from '../../../../helpers/type-helper'
import { ChangeStatusSelectItem } from './../../../common/change-status/change-status.directive.controller'
import { ConvertHelper } from './../../../../helpers/convert-helper'
import { TemplateHelper, ToastHelper } from '../../../../helpers'
import { CreateEditInitParams, CreateEditPopupOptions } from '../../../common/create-edit-popup/create-edit-popup.controller'
import { UserSessionService } from '../../../../services/user-session'
import { ReferenceTypeService } from '../../../../services/reference-type'
import { ExtendedFormItem } from '../../../common/common.create-edit'
import { DropDownBox } from '../../../common/drop-down-box/drop-down-box.interfaces'
import { OperatorSecurityService } from '../../../../services/operator'

type SelectPopoverData = {
	valueId: number
	dataTypeId: number
	value: string
}

type LocationData = {
	city?: string
	address?: string
	zip?: string
	lat?: number
	lng?: number
}

interface PecGliwiceDataTypeGroupCreateEditScope extends ng.IScope {
	// popup
	popupOptions: DevExpress.ui.dxPopupOptions
	closeButtonOptions: DevExpress.ui.dxButtonOptions
	popupVisible: boolean
	modelId: number
	tabsOptions: DevExpress.ui.dxTabsOptions
	tabsVisible: boolean
	tabItems: { template: (itemData: any, itemIndex: number, itemElement: HTMLElement) => string }[]
	panels: CreateEditSection[]
	dateFormat: string
	selectedTab: number
	isLoading: boolean
	noData: boolean

	locationDataChangePopupId: string

	toolbarOptions: DevExpress.ui.dxToolbarOptions

	options: CreateEditPopupOptions

	// location type
	// getCoords(): any
	onLocationSelected(lat: number, lng: number): void
	onPopoverValueIdSelected(valueId: number, dataTypeId: number, value: string, scriptArg: string, rowData: any, refrnceObject: IReferenceType): void

	// types / lists
	typeListsNames: string[]

	locationData: LocationData

	//localization
	confirmText: string
	noDataText: string
}

export class PecGliwiceDataTypeGroupCreateEditPopupController extends CommonCreateEdit {
	private originalData: CreateEditField[]

	private tabs: DevExpress.ui.dxTabs
	private entityId: number = null

	// select boxes and events for distributor
	private f: DevExpress.ui.dxSelectBox

	private selectedPopoverData: SelectPopoverData[] = []

	private popup: DevExpress.ui.dxPopup

	private previousSectionState: string
	private submitFailed: boolean = false

	private isClosed: boolean
	private idReferenceType: number

	private referenceObject: IReferenceType & IOpObject

	private referenceValueFormInstance: DropDownBox
	private idReferenceFormInstance: DevExpress.ui.dxSelectBox
	private parentReferenceValueFormInstance: DropDownBox
	private parentIdReferenceFormInstance: DevExpress.ui.dxSelectBox

	/**indicate when need to reload custom controlls with their reauest to WS */
	private needUpdateForm: boolean = true

	constructor(
		protected $scope: PecGliwiceDataTypeGroupCreateEditScope,
		protected $q: ng.IQService,
		protected $timeout: ng.ITimeoutService,
		protected api: Api,
		protected localDictionary: LocalDictionaryFactory,
		protected userSession: UserSessionService,
		protected referenceTypeService: ReferenceTypeService,
		protected readonly operatorSecurityService: OperatorSecurityService
	) {
		super($scope, api, localDictionary, $q, $timeout, userSession, referenceTypeService, operatorSecurityService)

		this.setOptions()
		this.setEvents()
	}

	//#region Events

	private setEvents(): void {
		this.$scope.$on(EventsNames.ESC_KEY_PRESS, () => {
			if (this.$scope.popupOptions != null) {
				this.$timeout(() => {
					this.closeDetails()
				})
			}
		})

		// show popup
		this.$scope.$on(EventsNames.SHOW_CREATE_EDIT_POPUP, (event, ...args: any[]) => {
			this.onShowCreateEditPopup()
		})

		// initialize panels with forms and grids
		this.$scope.$on(EventsNames.OPEN_CREATE_EDIT_POPUP_DATA_TYPE_GROUP_PEC_GLIWICE, (event: ng.IAngularEvent, ...args: any[]) => {
			if (this.isClosed) {
				this.$scope.isLoading = false

				return
			}

			this.onShowPopup(args)
		})

		// close
		this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
			this.onCloseCreateEditPopup(args)
		})
	}

	private onShowCreateEditPopup(): void {
		this.editedItems = {}

		this.isClosed = false
		this.$scope.popupVisible = true
		this.$scope.isLoading = true
		this.$scope.noData = false
	}

	private onShowPopup(args: any[]): void {
		if (_.size(args) > 0) {
			this.popup.show().then(() => {
				this.$scope.popupVisible = true
				this.$scope.isLoading = false
				const params: CreateEditInitParams = args[0]
				const sections: CreateEditSection[] = _.clone(params.sections)
				let initialData: CreateEditField[]
				this.idReferenceType = params.idReferenceType
				let selectedTab: number

				const opObject: IOpObject = params.referenceObject
				this.referenceObject = params.referenceObject
				const dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)

				sections.forEach((section: CreateEditSection) => {
					section.columns = section.dataTypesToEdit.map((c: OpDataTypeInGroup) => {
						const opDataTypeInGroup: OpDataTypeInGroup = c
						dataTypeDict.addOrUpdate(opDataTypeInGroup.idDataType, opDataTypeInGroup.dataType)

						const settings = {
							id: opDataTypeInGroup.idDataType,
							caption: opDataTypeInGroup.toString(),
							referenceTypeId: opDataTypeInGroup.dataType.idReferenceType, // ??
							unitName: opDataTypeInGroup.dataType.unit.name, // usunąć
							type: opDataTypeInGroup.dataType.idDataTypeClass, //??
							format: opDataTypeInGroup.dataType.dataTypeFormat ? opDataTypeInGroup.dataType.dataTypeFormat : {}, //??
							isEditable: opDataTypeInGroup.dataType.isEditable,
						}

						settings['defaultValue'] = opDataTypeInGroup.dataType.defaultValue

						return settings as CreateEditFieldSettings
					})

					section.required = section.dataTypesRequired.map((c: OpDataTypeInGroup) => {
						const opDataTypeInGroup: OpDataTypeInGroup = <any>c
						return <CreateEditFieldSettings>{
							id: opDataTypeInGroup.idDataType,
							caption: opDataTypeInGroup.toString(),
							referenceTypeId: opDataTypeInGroup.dataType.idReferenceType,
							unitName: opDataTypeInGroup.dataType.unit.name,
							type: opDataTypeInGroup.dataType.idDataTypeClass,
							format: opDataTypeInGroup.dataType.dataTypeFormat ? opDataTypeInGroup.dataType.dataTypeFormat : {},
							isEditable: opDataTypeInGroup.dataType.isEditable,
						}
					})
				})

				if (opObject) {
					initialData = opObject.dataList
						.toArray()
						.map((d: IOpData) => {
							const dataType: OpDataType = dataTypeDict.tryGetValue(d.idDataType)
							if (dataType) {
								return <CreateEditField>{
									id: d.idData,
									idDataType: d.idDataType,
									index: d.indexNBR,
									name: d.idDataType + '',
									value: d.value,
									typeId: dataType ? dataType.idDataTypeClass : 0,
									rowColor: (<any>d).statusColor,
								}
							}
							return null
						})
						.filter((d: CreateEditField) => d != null)
				}
				this.$scope.modelId = params.referenceObject ? params.referenceObject.getReferenceKey() : params.referenceObjectId
				selectedTab = params.createEditSelectedTabType

				this.originalData = _.clone(initialData)

				this.$timeout(() => {
					if (selectedTab) {
						this.$scope.selectedTab = selectedTab
					} else {
						this.$scope.selectedTab = 0
					}
				}, 500)

				if (!sections || sections.length == 0) {
					this.$scope.noData = true
				} else {
					sections.forEach((section: CreateEditSection) => {
						if (section.dataTypesToEdit != null && section.dataTypesToEdit.length === 0) {
							sections.splice(sections.indexOf(section), 1)
						}
					})
				}

				this.entityId = this.$scope.modelId

				this.updateTabs(this.$scope, sections)
				this.$scope.panels = []

				const mappedData: { [key: number]: CreateEditField } = {}

				if (initialData == null) {
					initialData = []
				}
				initialData.forEach((data: CreateEditField) => {
					if (data.index == 0) mappedData[data.idDataType || data.id] = data
				})

				sections.forEach((section: CreateEditSection) => {
					switch (section.type) {
						default:
						case 'form':
							this.createForm(section, mappedData, this.idReferenceType)
							break
					}
					this.$scope.panels.push(section)
				})
			})
		}
	}

	private onCloseCreateEditPopup(args: any[]): void {
		if (_.size(args) > 0) {
			this.isClosed = true

			const needClosePopup: boolean = args[1]
			if (needClosePopup != false) {
				this.$scope.popupVisible = false
			}
		}
	}

	private onSectionFieldDataChanged(data: { [key: number]: CreateEditField }, dataField: number, value: any): void {
		if (data[dataField]) {
			let oldValue: any = data[dataField].value
			if (data[dataField].typeId == CommonHelper.datetime || data[dataField].typeId == CommonHelper.date) {
				oldValue = moment(oldValue).toDate()
				if (oldValue != null || value == null || oldValue == null || value != null || (oldValue != null && value != null && oldValue.getTime() != value.getTime())) {
					this.editedItems[dataField] = true
				} else if (oldValue.getTime() == value.getTime()) {
					this.editedItems[dataField] = false
				}
			} else {
				if (oldValue != value) {
					this.editedItems[dataField] = true
				} else if (oldValue == value) {
					this.editedItems[dataField] = false
				}
			}
		}
	}

	private onGmapLocationSelected(args: any[]): void {}

	private onLocationSelectInitialized(args: any[]): void {}

	//#endregion

	//#region Options

	private setOptions(): void {
		this.$scope.isLoading = true

		this.$scope.noDataText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData)
		this.$scope.confirmText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm)

		this.$scope.locationDataChangePopupId = new Date().getTime() + 'location'

		//popup
		this.$scope.dateFormat = window['simax'].getDateFormat('DATE_FORMAT_DX')
		this.$scope.popupVisible = false

		this.$scope.popupOptions = {
			bindingOptions: {
				visible: 'popupVisible',
				title: 'options.title',
			},
			fullScreen: false,
			showTitle: true,
			closeOnOutsideClick: false,
			maxWidth: (): number => {
				return $(window).width() * 0.4
			},
			height: (): number => {
				return $(window).height() * 0.6
			},
			onHiding: (e: any): void => this.closePopup(),
			onInitialized: (e: any): void => {
				this.popup = e.component
			},
			onShowing: (e: any): void => {
				this.previousSectionState = ''
			},
		}

		//tabs
		this.$scope.selectedTab = -1
		this.$scope.tabItems = []
		this.$scope.tabsOptions = {
			bindingOptions: {
				visible: 'tabsVisible',
				items: 'tabItems',
				selectedIndex: 'selectedTab',
			},
			onInitialized: (e: any): void => {
				this.tabs = e.component
			},
			onSelectionChanged: (e: any): void => {
				if (this.$scope.panels && this.$scope.panels[this.$scope.selectedTab] && this.$scope.panels[this.$scope.selectedTab].grid) {
					this.$scope.panels[this.$scope.selectedTab].grid.refresh()
				}
			},
		}

		this.$scope.closeButtonOptions = {
			template: TemplateHelper.getIcon(ConfigHelper.Icon.CLOSE, this.userSession),
			onClick: (e: any) => this.closeDetails(),
		}

		this.$scope.toolbarOptions = {
			items: [
				{
					location: 'after',
					widget: 'dxButton',
					options: {
						text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Apply),
						onClick: (): void => {
							this.submit()
						},
					},
				},
			],
		}

		this.$scope.onLocationSelected = (lat: number, lng: number): void => {}

		this.$scope.onPopoverValueIdSelected = (valueId: number, datatypeId: number = null, value: string = null, scriptArg: string, rowData: any, referenceObject: IReferenceType): void => {
			this.onPopoverValueIdSelected(valueId, datatypeId)

			this.selectedPopoverData = this.selectedPopoverData.filter((item: SelectPopoverData) => {
				return item.dataTypeId != datatypeId
			})
			this.selectedPopoverData.push({ valueId: valueId, dataTypeId: datatypeId, value: value })
		}
	}

	private getFormOptions(section: CreateEditSection, data: { [key: number]: CreateEditField }, idReferenceType: number): DevExpress.ui.dxFormOptions {
		const formOptions: DevExpress.ui.dxFormOptions = {
			requiredMark: '*',
			showRequiredMark: true,
			labelLocation: 'top',
			width: '100%',
			height: '100%',
			scrollingEnabled: true,
			colCount: 1,
			bindingOptions: {
				formData: 'panel.formData',
				// items: 'panel.items',
			},
			onInitialized: (e: any): void => {
				section.form = e.component

				this.$timeout(() => {
					if (_.size(section.columns) > 0) {
						const referenceTypeField: CreateEditField = data[Enums.DataType.HELPER_ID_REFERENCE_TYPE]
						const referenceValueColumn = _.find(section.columns, (column: CreateEditFieldSettings) => column.id == Enums.DataType.HELPER_REFERENCE_VALUE)
						if (referenceTypeField != null && referenceValueColumn != null) {
							referenceValueColumn.referenceTypeId = referenceTypeField.value
						}
					}

					this.loadForm(section, data, this.$scope.options.type, idReferenceType).then(() => {
						this.prepareCustomFormItems(section)

						section.form.option({ items: section.items })
					})
				})
			},
			onFieldDataChanged: (e: any): void => {
				this.onSectionFieldDataChanged(data, e.dataField, e.value)
				this.trackChanges(section, e.dataField, e.value)
			},
		}
		return formOptions
	}

	//#endregion

	//#region pec-gliwice custom form

	private prepareCustomFormItems(section: CreateEditSection): void {
		const formSection: CreateEditSection = _.find(this.$scope.panels, (section: CreateEditSection) => section.type === 'form')

		if (formSection != null && formSection.formData != null) {
			this.prepareControllForAllowedDataTypeGroups(formSection)
		}
	}

	private prepareControllForAllowedDataTypeGroups(section: CreateEditSection): void {
		const allowedDataTypeGroups: OpProfileData[] =
			this.userSession.getLoggedOperator().profile != null && this.userSession.getLoggedOperator().profile.parameters != null
				? _.filter(this.userSession.getLoggedOperator().profile.parameters.toArray(), (data: OpProfileData) => data.idDataType == Enums.DataType.PROFILE_ALLOWED_DATA_TYPE_GROUP)
				: null

		if (_.size(allowedDataTypeGroups) > 0) {
			const nameValueControl: ExtendedFormItem = _.find(section.items, (item: ExtendedFormItem) => {
				return +item.dataField == Enums.DataType.HELPER_NAME
			})

			if (nameValueControl != null) {
				this.$scope[`referenceTable${Enums.DataType.HELPER_NAME}`] = _.map(allowedDataTypeGroups, (group: OpProfileData) => {
					return {
						id: group.value,
						caption: group.value,
					}
				})
				nameValueControl.template = super.getDefaultSelectBoxTemplate(Enums.DataType.HELPER_NAME, `referenceTable${Enums.DataType.HELPER_NAME}`, false, section)
			}
		}
	}

	private onReferenceTypeSelectionChanged(e: any, section: CreateEditSection, idDataType: Enums.DataType): void {
		const column: CreateEditFieldSettings = _.find(section.columns, (column: CreateEditFieldSettings) => +column.id == idDataType)

		if (idDataType == Enums.DataType.HELPER_ID_REFERENCE_TYPE) {
			if (this.referenceValueFormInstance != null) {
				this.referenceValueFormInstance.changeReferenceType(e.selectedItem != null ? e.selectedItem.id : null)
			}
		} else if (idDataType == Enums.DataType.HELPER_PARENT_ID_REFERENCE_TYPE) {
			if (this.parentReferenceValueFormInstance != null) {
				this.parentReferenceValueFormInstance.changeReferenceType(e.selectedItem != null ? e.selectedItem.id : null)
			}
		}
	}

	//#endregion

	//#region Custom

	private closeDetails(): void {
		this.isClosed = true

		this.$scope[this.getDropDownOptionFieldName(Enums.DataType.HELPER_ID_REFERENCE_TYPE)] = null
		this.referenceValueFormInstance = null

		this.$scope[this.getDropDownOptionFieldName(Enums.DataType.HELPER_PARENT_ID_REFERENCE_TYPE)] = null
		this.parentReferenceValueFormInstance = null

		this.$scope.popupVisible = false
		if (this.$scope != null && this.$scope.options != null && this.$scope.options.onClose != null && TypeHelper.isFunction(this.$scope.options.onClose)) {
			this.$scope.options.onClose()
		}
	}

	private updateTabs($scope: PecGliwiceDataTypeGroupCreateEditScope, sections: CreateEditSection[]): void {
		$scope.tabItems = sections.map((section: CreateEditSection) => {
			return {
				template: (itemData: any, itemIndex: number, itemElement: HTMLElement): string => {
					this.$scope['showSectionError' + itemIndex] = false
					return (
						section.name +
						'<ng-md-icon ng-show="showSectionError' +
						itemIndex +
						'" icon="' +
						window['config']['ICONS']['REQUIRED_TAB'] +
						'" style="fill: #ea4444; vertical-align: middle;" size="20"></ng-md-icon>'
					)
				},
			}
		})
		$scope.tabsVisible = $scope.tabItems.length > 1
	}

	private updateFormData(section: CreateEditSection, dataField: string | number, value: any): void {
		if (section.formData[dataField] != value) {
			section.formData[dataField] = value
			this.editedItems[dataField] = true
		}
	}

	private createForm(section: CreateEditSection, data: { [key: number]: CreateEditField }, idReferenceType: number): void {
		section.formData = {}
		section.items = []

		section.onFieldChanged = (e: any, idDataType: number = null): void => {
			const dataField: string = idDataType || e.element.get(0).attributes['table-id'].nodeValue

			if (dataField) {
				let value: any = null
				if (e.selectedItem) {
					let number: number = parseFloat(e.selectedItem.id)
					if (!isNaN(number)) value = number
					else value = e.selectedItem.id
				}

				if (+dataField == Enums.DataType.HELPER_ID_REFERENCE_TYPE) {
					this.idReferenceFormInstance.option(<DevExpress.ui.dxSelectBoxOptions>{ searchEnabled: true, showClearButton: true })
					this.onReferenceTypeSelectionChanged(e, section, +dataField)
				}

				if (+dataField == Enums.DataType.HELPER_PARENT_ID_REFERENCE_TYPE) {
					this.parentIdReferenceFormInstance.option(<DevExpress.ui.dxSelectBoxOptions>{ searchEnabled: true, showClearButton: true })
					this.onReferenceTypeSelectionChanged(e, section, +dataField)
				}

				if (+dataField == Enums.DataType.HELPER_ID_PARENT_GROUP) {
					if (this.parentReferenceValueFormInstance != null) {
						this.parentReferenceValueFormInstance.changeReferenceType(null)
						this.parentReferenceValueFormInstance.readOnly(!!value)
					}

					if (this.parentIdReferenceFormInstance != null) {
						this.parentIdReferenceFormInstance.reset()
						this.parentIdReferenceFormInstance.option({ readOnly: !!value })
					}
				}

				this.updateFormData(section, dataField, value)
			}
		}

		section.onDateFieldChanged = (e: any): void => {
			this.trackChanges(section, e.element.get(0).attributes['table-id'].nodeValue, e.value)
		}

		section.onFieldValueChanged = (e: any): void => {}

		section.initializedHandler = (e: any, idDataType?: number): void => {
			const dataField: string = idDataType || e.element.get(0).attributes['table-id'].nodeValue
			const referencefieldsReadOny: boolean = false //this.referenceObject != null && this.referenceObject.idObject > 0 && _.size((<OpDataTypeGroup>this.referenceObject).currentDataTypesInGroup) > 0

			if (+dataField == Enums.DataType.HELPER_REFERENCE_VALUE) {
				this.referenceValueFormInstance = e.component
			}

			if (+dataField == Enums.DataType.HELPER_ID_REFERENCE_TYPE) {
				this.idReferenceFormInstance = e.component
			}

			if (+dataField == Enums.DataType.HELPER_PARENT_REFERENCE_VALUE) {
				this.parentReferenceValueFormInstance = e.component
			}

			if (+dataField == Enums.DataType.HELPER_PARENT_ID_REFERENCE_TYPE) {
				this.parentIdReferenceFormInstance = e.component
			}
		}

		section.onSelectNoteValueChanged = (value: ChangeStatusSelectItem, idDataType: Enums.DataType): void => {}

		section.onNoteValueChanged = (value: string, idDataType: Enums.DataType): void => {}

		section.options = null
		this.$timeout(() => {
			section.options = this.getFormOptions(section, data, idReferenceType)
		})
	}

	private trackChanges(section: CreateEditSection, idDataType: number, value: any, index: number = 0): void {
		this.$scope.panels.forEach((panel: CreateEditSection) => {
			if (panel != section) {
				if (panel.form && index == 0 && panel.columns.map((c) => c.id).indexOf(idDataType) > -1) {
					if (panel.formData[idDataType] != value) {
						this.editedItems[idDataType] = true
						panel.formData[idDataType] = value
					}
				}
			}
		})
	}

	private getId(index: number, idDataType: number): number {
		if (this.originalData != null) {
			const models: CreateEditField[] = this.originalData.filter((d: CreateEditField) => d.index == index && d.idDataType == idDataType)
			if (models.length > 0) {
				return models[0].id
			}
		}
		return null
	}

	private submit(): void {
		const sections: CreateEditSection[] = this.$scope.panels

		if (this.isSectionsValid(sections) == true) {
			let unique: { index: number; idDataType: number }[] = []
			let fields: FieldNameValueModel[] = []

			sections.forEach((section: CreateEditSection) => {
				if (section.form != null) {
					Object.keys(section.formData).forEach((property: string) => {
						let idDataType: number = parseInt(property)
						if (unique.filter((o: { index: number; idDataType: number }) => o.index == 0 && o.idDataType == idDataType).length == 0) {
							const id: number = this.getId(0, idDataType)
							let state: Enums.OpChangeState = Enums.OpChangeState.New
							let isHelperField: boolean = false
							const dataType: OpDataType = this.userSession.getDataProvider().DataType.getDataTypeLocal(idDataType)
							if (dataType != null) {
								isHelperField = dataType.name.indexOf('HELPER_') == 0
							}
							if (id || isHelperField) {
								if (this.editedItems[idDataType]) {
									state = Enums.OpChangeState.Modified
								} else {
									state = Enums.OpChangeState.Loaded
								}
							}
							let nameValue: FieldNameValueModel = new FieldNameValueModel()
							nameValue.idDataType = idDataType
							nameValue.id = id ? id : 0
							nameValue.index = 0
							nameValue.value = section.formData[property]

							if (dataType != null) {
								nameValue.value = ConvertHelper.prepareDataValue(nameValue.value, dataType)
							}

							nameValue.state = state
							fields.push(nameValue)
							unique.push({ index: 0, idDataType: idDataType })
						}
					})
				}
			})

			let currentMd5: string = Md5.init({ fields, entityId: this.entityId })
			if (this.previousSectionState !== currentMd5 || this.submitFailed) {
				this.$scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)
				this.previousSectionState = currentMd5

				const objectToSave: IOpObject = <IOpObject>(<any>ReferenceTypeComponent.createReferenceObject(this.idReferenceType, {}))
				objectToSave.idObject = this.entityId
				objectToSave.dataList = new OpDataList<IOpData>()
				fields.forEach((f: FieldNameValueModel) => {
					const objectDataToSave: IOpData = <IOpData>{}
					objectDataToSave.idDataType = f.idDataType
					objectDataToSave.indexNBR = f.index
					objectDataToSave.value = f.value
					objectDataToSave.opState = f.state
					objectToSave.dataList.push(objectDataToSave)
				})
				objectToSave.opState = objectToSave.idObject == 0 ? Enums.OpChangeState.New : Enums.OpChangeState.Modified

				this.$scope.options
					.onSave(objectToSave)
					.then((result: IOpObject) => {
						if (!result) {
							this.submitFailed = true
						} else {
							this.submitFailed = false
						}
					})
					.catch(() => {
						this.submitFailed = true
					})
					.finally(() => {
						this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
					})
			}
		} else {
			ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IncorrectData), { displayTime: 5000 })
			angular.element('.dx-invalid').css('height', '36px')
		}
	}

	private onPopoverValueIdSelected(valueId: number, datatypeId): void {
		this.$scope.panels.forEach((panel: CreateEditSection) => {
			if (panel.form != null && panel.formData != null) {
				if (panel.formData[datatypeId] !== undefined) {
					if (valueId) {
						angular
							.element('.data_type_id_' + datatypeId)
							.find('.dx-invalid')
							.removeClass('dx-invalid')
					}
					panel.formData[datatypeId] = valueId
					this.editedItems[datatypeId] = true
				}
			}
		})
	}

	private closePopup(): void {
		this.isClosed = true
		this.$scope.panels = []
		this.selectedPopoverData = []
	}

	//#endregion
}
